import {Tabs, TabsColorScheme, TabsContainer} from "@/shared/TabsContainer";
import {HomeOutlined} from "@mui/icons-material";
import {DashboardFragment} from "./dashboard/DashboardFragment";
import React from "react";
import {PathComponent} from "@/index";
import {AppTabsContainer} from "@/shared/AppTabsContainer";
import {BaseModuleMain, BaseModuleMainProps, BaseModuleMainState,} from "@/elements-shared/BaseModuleMain";
import {BaseApp} from "@/shared/BaseApp";

enum Tab {
  DASHBOARD = "dashboard",
}

const TABS: Tabs<Tab> = {
  items: [
    {
      type: Tab.DASHBOARD,
      path: "dashboard",
      text: "Dashboard",
      iconType: HomeOutlined,
      render: path => <DashboardFragment path={path}/>,
    },
  ],
  containerId: "main",
}

export type ModuleMainProps = BaseModuleMainProps & {}

type ModuleMainState = BaseModuleMainState & {}

export class ModuleMain extends BaseModuleMain<ModuleMainProps, ModuleMainState> {

  static nestedPaths(prefixPath?: string): PathComponent[] {
    return TabsContainer.nestedPathsFromTabs(TABS, prefixPath);
  }

  protected renderContainerContent(): React.ReactElement | null {
    const tabsColorScheme: TabsColorScheme = BaseApp.CONTEXT.getPreferredColorScheme() || "light";
    return <AppTabsContainer
      path={this.props.path}
      modulePath={this.props.modulePath}
      noLogo={true}
      noUserButton={true}
      tabs={TABS}
      tabsThemeColor={this.theme.palette.grey[tabsColorScheme as string === "light" ? 100 : 900]}
      tabsColorScheme={tabsColorScheme}
    />;
  }
}